import axios from "../reducers/authinterceptor";
import AuthHeader from "../services/auth.header";

/** Default true — Featured page is the home landing. */
export const usesFeaturedHome = (subsite) => {
  if (!subsite) return true;
  return !(subsite.showFeaturedPage === false || subsite.showFeaturedPage === 0 || subsite.showFeaturedPage === "false");
};

/**
 * Resolve post-login / logo home path for a subsite.
 * Priority: NHK lock → kit home → featured or first category.
 */
export const resolveRetailHomePath = async (subsite, { nhkLocked = false } = {}) => {
  if (nhkLocked) return "/newhirekit";
  if (subsite && subsite.paymentOptions === "kit") return "/kithome";
  if (usesFeaturedHome(subsite)) return "/featured";

  try {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/categories",
      { headers: AuthHeader.authHeader() }
    );
    const menu = response.data;
    if (Array.isArray(menu) && menu.length > 0 && menu[0].id) {
      return `/productlist/${menu[0].id}`;
    }
  } catch (err) {
    console.error("Failed to resolve first category for retail home", err);
  }
  return "/featured";
};
